import React, { useEffect, useState } from 'react';

interface HeroTypewriterTitleProps {
  text: string;
  typingSpeed?: number;
  className?: string;
}

const HeroTypewriterTitle: React.FC<HeroTypewriterTitleProps> = ({
  text,
  typingSpeed = 55,
  className = '',
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setDisplayedText('');
    setCurrentIndex(0);
  }, [text]);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timer = setTimeout(() => {
        setDisplayedText(text.slice(0, currentIndex + 1));
        setCurrentIndex((index) => index + 1);
      }, typingSpeed);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [currentIndex, text, typingSpeed]);

  const typingDone = currentIndex >= text.length;

  return (
    <h1 className={`hero-title ${className}`.trim()} aria-label={text}>
      <span className={`hero-title-display gradient-text ${typingDone ? '' : 'typewriter'}`}>
        {typingDone ? (
          text
        ) : (
          <>
            {displayedText}
            <span className="typewriter-cursor" aria-hidden="true">
              |
            </span>
          </>
        )}
      </span>
    </h1>
  );
};

export default HeroTypewriterTitle;
